import { render, staticRenderFns } from "./report-found-imgbox.vue?vue&type=template&id=4320ff0c"
import script from "./report-found-imgbox.vue?vue&type=script&lang=js"
export * from "./report-found-imgbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports